export default {
  header: {
    menu: {
      home: 'Home',
      products: '产品',
      solutions: '解决方案',
      announcements: '官方公告',
      contact: '联系我们'
    },
    submenu: {
      accountService: '开户/注册服务',
      accountServiceDesc: '解决开户失败或账户限制问题',
      dataAnalysis: '数据分析与报告解读',
      dataAnalysisDesc: '为客户生成清晰的广告效果报告，分析数据背后的关键指标',
      adDesign: '广告系列设计与设置',
      adDesignDesc: '为客户量身定制广告策略，提供详细的广告创建教程',
      adRejection: '广告被拒问题处理',
      adRejectionDesc: '指导客户修改广告并重新提交审核，提供申诉流程指导',
      optimization: '投放优化与预算分配',
      optimizationDesc: '提供实时优化支持,预算分配新手教学',
      qa: '问题解答',
      qaDesc: '为客户提供全天候技术支持'
    },
    products: {
      kuamao: '跨贸号铺',
      kuamaoDesc: 'Outlook邮箱购买|Hotmail邮箱购买|邮箱批发|推特账号批发|海外邮箱购买|海外账号邮箱批发',
      eyou: '以渔 EYOU',
      eyouDesc: '大媒体账号集中管理系统',
      card: "趣汇付",
      cardDesc: "趣汇付提供企业级虚拟卡发行与管理服务。即时生成无限量 Visa/Mastercard 虚拟卡，满足广告投放、SaaS 订阅及差旅支出需求，无需任何实体卡。"
    },
    kf: {
      telegram: 'telegram客服',
      wechat: '微信客服'
    },
    message: {
      stayTuned: '敬请期待'
    }
  },
  home: {
    nav: {
      discuss: '与您共同探讨',
      infinite: '出海营销的无限可能',
      experience: '立即体验'
    },
    intro: {
      title: '我们是一家专注于出海营销的广告公司，致力于为客户提供跨境营销解决方案',
      desc: '我们拥有丰富的经验和专业的团队，不限品类，为客户提供极速开户和专业运营代投，包括Facebook、Google、TikTok和Kwai等众多海外媒体平台全方位服务。'
    },
    carousel: {
      items: [
        { title: '你是否需要低成本 获取流量但缺乏专业广告投放经验？' },
        { title: '你是否需要将 Facebook 广告作为销售渠道的主要来源，并覆盖海外市场？' },
        { title: '你是否希望快速建立 品牌曝光和用户基础？' }
      ],
      contact: '联系我们'
    },
    coreBusiness: {
      title: '我们的核心业务',
      account: {
        title: '开户与账号管理',
        desc: '为客户完成 Facebook 广告账户的创建和管\n理，包括审核流程的处理和开户资料的准备\n指导。'
      },
      strategy: {
        title: '广告投放策略',
        desc: '助客户设计广告系列，包括预算分配、目标\n定位和投放优化等。'
      },
      support: {
        title: '问题解决服务',
        desc: '提供高效的售后支持，解答客户在广告使用\n过程中遇到的常见问题，例如账户限制或广\n告被拒。'
      }
    },
    serviceScope: {
      title: '我们的服务范围',
      card1: {
        title: '开户/注册服务',
        li1: '提供开户资料清单（例如身份证明、企业营业执照、信用卡信息等）',
        li2: '协助客户提交申请，确保资料符合 Facebook 审\n核要求。',
        li3: '解决开户失败或账户限制问题。'
      },
      card2: {
        title: '广告系列设计与设置',
        li1: '为客户量身定制广告策略，根据其业务目标（如品牌曝光、引流、销售转化）提供个性化建议。',
        li2: '提供详细的广告创建教程，包括目标选择、受众定位、广告创意设计、投放日程规划等。'
      },
      card3: {
        title: '投放优化与预算分配',
        li1: '教客户如何分配预算（如测试期低预算试投 vs. 成\n熟期高预算扩大投放）。',
        li2: '提供实时优化支持，例如根据数据调整受众、广告创意或投放时间。'
      },
      card4: {
        title: '数据分析与报告解读',
        li1: '为客户生成清晰的广告效果报告（例如点击率、转化率、展示次数等）。',
        li2: '分析数据背后的关键指标，找出低效广告并提供改进建议。'
      },
      card5: {
        title: '广告被拒问题处理',
        li1: '分析广告被拒原因（例如违反政策、图片或文字内容违规）。',
        li2: '指导客户修改广告并重新提交审核。',
        li3: '提供申诉流程指导，快速解决问题。'
      },
      card6: {
        title: '使用过程中问题解答',
        li1: '为客户提供全天候技术支持，解决使用中遇到的账户登录、功能操作或政策更新问题。',
        li2: '针对客户反馈开发常见问题（FAQ）库，提升服务\n效率。'
      }
    },
    whyChoose: {
      title: '为什么选择我们',
      connect: '联系我们',
      platform: {
        title: '多平台覆盖',
        desc: '官方一代媒体，包括Facebook、Google、TikTok、Kwai等主流媒体平台和其他平台。'
      }
    },
    features: {
      custom: {
        title: '量身定制',
        subtitle: '专业团队',
        desc: '我们拥有一支经验丰富、充满创意的团队，擅长制定针对不同市场的出海营销策略。'
      },
      precise: {
        title: '精准投放',
        subtitle: '运营服务',
        desc: '我们能够精确地调整和优化您的广告投放策略，以提高转化率和投资回报率。'
      },
      worryFree: {
        title: '省心省力',
        subtitle: '服务保障',
        desc: '我们提供一站式的开户和代运营服务，为您节省时间和精力。'
      }
    },
    footer: {
      partner: '官方合作伙伴',
      connect: '联系我们'
    }
  },
  kf: {
    telegram: 'telegram客服',
    wechat: '微信客服'
  },
  connect: {
    join: '是时候加入\nBravotree出海专家了',
    try: '欢迎立即尝试并深度体验！',
    contact: '联系我们',
    exchange: '期待与您的交流',
    form: {
      name: '名字',
      namePlaceholder: '请输入您的名字',
      email: 'Email',
      emailPlaceholder: 'example@yourmail.com',
      surname: '姓氏',
      surnamePlaceholder: '请输入您的姓氏',
      company: '公司名称',
      companyPlaceholder: '请输入您的公司全名',
      telegram: 'Telegram',
      telegramPlaceholder: '告诉我们您的Telegram账号，以便我们可以更好的了解您...',
      submit: '提交',
      success: '提交成功',
      error: '提交失败',
      validName: '请输入您的名字',
      validEmail: '请输入您的邮箱',
      validEmailFormat: '请输入正确的邮箱地址',
      validSurname: '请输入您的姓氏',
      validCompany: '请输入您的公司名称',
      validTelegram: '请输入您的Telegram账号'
    }
  },
  announcement: {
    title: '防骗公告',
    content: '近期，部分客户遭遇了虚假广告、付款后账户被删除、以各种理由拒绝退款，以及模仿其他服务公司进行诈骗等欺诈行为。为保障您的权益，特发布以下防骗公告。',
    tipsTitle: '防骗技巧：',
    tips: [
      '1.声称<span>不限制</span>行业的，所有都能投放的。',
      '2.针对行业细节，以及运营账户细节不知道的。',
      '3.服务费<span>明显低于</span>市场的。',
      '4.对于你的要求，他们都能顺从的。',
      '5.竭力满足您的各种想法，<span>诱导</span>您付款投放的。'
    ],
    normalProcessTitle: '正常流程',
    warning: [
      '请您在选择服务时，务必提高警惕，避免上当受骗。',
      '如有任何疑问或需要进一步了解，请随时与<span @click="openRandomLink()">我们联系</span>。'
    ],
    process: [
      '<span>1.</span>客户提供产品和投放地区我们进行评估看适合的平台，或者客户要求的平台。',
      '<span>2.</span>针对产品的风控要求，提供总结，供客户决策。',
      '<span>3.</span>确定投放方案后，无需预付款，先进行账户审核，审核通过后再付款。'
    ],
    menu: ['官方公告']
  },
  solution1: {
    nav: {
      oneStop: '一站式',
      register: '广告账户注册服务，',
      easyStart: '轻松开启您的广告之旅！',
      desc: '不论您是第一次做广告投放，还是已有一定经验，我们的广告账户开户注册服务将为您提供专业的帮助。从准备开户资料到解决账户审核问题，我们始终为您提供全程支持，帮助您快速启动广告投放。',
      btn: '立即体验'
    },
    modules: {
      num: '3',
      title: '大服务模块',
      card1: {
        title: '开户资料整理与指导',
        desc: '我们会为您提供详细的开户资料清单，确保您准备齐全，并指导您如何确保资料的完整性与<br/>合规性，避免因信息不全导致的审核延误。',
        link: '现在使用专业归档服务'
      },
      card2: {
        title: '专业协助提交申请',
        desc: '我们会帮助您填写申请表格，上传所有必要的文件，并确保您提交的信息符合平台要求。<br/>这样，您就可以避免因资料不准确或不完整而导致的审核问题。',
        link: '我们将确保您提交成功'
      },
      card3: {
        title: '快速解决账户问题',
        desc: '如果您的账户在审核过程中被拒绝或被冻结，我们会提供专业的技术支持，帮助您找到问<br/>题的根源并提供解决方案。我们确保您重新提交资料时，能够顺利通过审核并激活账户。',
        link: '使用我们的专业激活服务'
      }
    },
    faq: {
      title: '常见问题解答',
      q1: 'Q: 为什么我的账户审核失败',
      a1: 'A: 审核失败的原因通常是资料不全或不符合平台要求。我们会为您分析失败原因，帮助您进行修改和重新提交。',
      q2: 'Q: 开户需要多长时间？',
      a2: 'A: 一般来说，平台审核时间为1-3个工作日，我们会为您跟踪审核进度并及时告知结果。',
      q3: 'Q: 如何避免账户被冻结或被封禁？',
      a3: 'A: 我们会提供详细的账户管理指导，帮助您避免常见的违规操作，确保账户安全。'
    }
  },
  solution2: {
    content1: {
      title1: '广告投放数据化运营',
      title2: '全程优化支持',
      desc: '通过专业的广告数据分析与报告解读，我们为客户提供清晰的广告表现洞察，精准发现优化机会，帮助客户实现更高的广告回报率ROI',
      btn: '立即体验'
    },
    content2: {
      title: '阶段性广告数据分析',
      desc: '通过低预算试投，分析受众反馈和广告表现，筛选最优策略，<br />集中资源于高效广告系列，同时持续优化细节，扩大覆盖面和影响力。',
      card1: '测试期数据评估',
      card2: '成熟期全面评估',
      btn: '开始评估'
    },
    content3: {
      title: '全方位报告与数据洞察',
      desc: '多维度指标分析，受众画像洞察，行业对标分析<br />让广告投放更具科学性和高效性'
    },
    content4: {
      title: '精准的优化行动方案',
      desc: '广告效果的背后，隐藏着大量值得深挖的优化信息<br />我们帮助客户解读数据，发现问题与机会',
      item1: {
        title: '数据驱动创意改进',
        desc: '根据用户互动数据，更新创意素材，提高广告吸引力。'
      },
      item2: {
        title: '投放路径优化',
        desc: '分析用户点击广告后的行为路径，优化落地页转化效果。'
      },
      item3: {
        title: '预算与渠道调整',
        desc: '灵活分配预算，优先投放高效广告系列，减少低效投放。'
      }
    }
  },
  solution3: {
    content1: {
      title1: '为您的品牌量身定制',
      title2: '精准广告系列',
      desc: '我们为您提供全方位的广告系列设计与设置服务，结合数据分析和行业经验，助力您的品牌在激烈的市场竞争中脱颖而出。',
      btn: '立即体验'
    },
    content2: {
      title: '每个成功的广告投放背后都离不开<br/>科学的策略和精准的执行',
      desc: '我们将为您提供完全定制化的广告策略<br/>确保广告系列与您的商业目标紧密对接',
      items: [
        { text: '品牌曝光<br/>提升影响力，覆盖目标受众' },
        { text: '引流<br/>精准定位，吸引优质流量' },
        { text: '销售转化<br/>优化创意与数据，提升转化率' },
        { text: '受众定位<br/>精准锁定客户群' },
        { text: '创意优化<br/>提供高质量素材，提升吸引力' },
        { text: '投放规划<br/>合理安排预算与时间' }
      ]
    },
    content3: {
      title: '我们将帮助您不断优化广告效果',
      items: [
        { title: '广告数据分析', desc: '定期对广告的点击率、转化率、ROI等关键指标进行分析，确保广告效果可量化。' },
        { title: 'A/B测试', desc: '不断进行A/B测试，选择表现最好的广告素材和策略，以持续提升广告效果。' },
        { title: '实时调整', desc: '我们的团队会根据广告投放数据实时调整策略，确保广告效果持续优化。' }
      ]
    }
  },
  solution4: {
    content1: {
      title: '广告被拒问题处理服务',
      desc: '我们深谙各大广告平台的审核规则与政策，无论您是因政策原因<br/>被拒，还是需要申诉支持，我们都能为您提供专业指导',
      btn: '立即体验'
    },
    content2: {
      title: '全面合规的广告内容整改服务',
      desc: '被拒的广告并不意味着营销终结，而是一次优化的机会<br/>我们将针对被拒原因提供改进建议，并指导客户优化广告内容',
      item1: {
        btn: '违规类型判断',
        desc: '我们将深入分析广告被拒背<br/>后的具体原因',
        title: '精准诊断广告被拒原因',
        list: [
          '详细分析广告被拒的反馈报告，确定主要违规原因（内容、技术或行业政策问题）。',
          '提供个性化的政策解读，帮助客户全面理解广告平台的审核规则。'
        ]
      },
      item2: {
        title: '申诉过程全程指导',
        list: [
          '协助客户通过广告平台申诉渠道提交申诉材料。',
          '跟进申诉进度，与广告平台审核团队保持有效沟通。'
        ],
        btn: '联系客服'
      },
      item3: {
        title: '快速审核支持',
        list: [
          '协助客户完成广告整改后的重新提交流程，跟踪审核进度，确保尽快通过。',
          '提供整改广告的全流程跟踪支持。'
        ],
        btn: '现在体验'
      }
    }
  },
  solution5: {
    nav: {
      title: '投放优化与预算分配',
      subtitle: '让广告效果',
      highlight: '一目了然',
      desc: '还在为广告预算怎么分配、投放效果不佳而烦恼？让我们帮您解决！通过科学的预算分配与实时优化策略，助力您的广告更高效、更省心。',
      btn: '立即体验'
    },
    content2: {
      title: '广告预算如何更高效？',
      item1: {
        title: '测试期精准试投',
        desc: '通过低预算测试，筛选表现优异的广告策略与受众群体，快速找到最佳广告组合。测试期的目的是以最低的成本探索出最佳的广告组合，避免无效支出，为后续的规模化投放奠定坚实基础。'
      },
      item2: {
        title: '成熟期规模扩展',
        desc: '在测试期结束后，进入广告投放的成熟阶段，此时的重点是扩大覆盖面、优化预算分配，并最大化转化效果。通过这一阶段的精准策略与深度优化，企业可以将广告的影响力最大化，吸引更多潜在客户并推动销售转化的全面提升。'
      }
    },
    content3: {
      title: '让广告效果更上一层楼',
      subtitle: '精准掌握广告投放的核心数据',
      connect: '联系我们',
      item1: {
        title: '受众精准优化',
        desc: '受众定位是广告成功的核心，通过精准优化目标人群，可以显著提高广告的触达效果和转化效率。通过精准的受众优化，广告不仅能够触达核心用户，还能有效挖掘潜在客户群体。'
      },
      items: [
        { title: '实时数据分析', desc: '实时数据分析是广告优化的起点，也是确保广告表现始终处于高效状态的关键手段。' },
        { title: '创意迭代更新', desc: '广告创意是吸引用户注意力的第一步。随着市场竞争的加剧，只有持续优化广告内容，才能保持用户的兴趣和互动意愿。' },
        { title: '时间与预算同步调整', desc: '时间和预算是广告投放中最重要的资源，我们通过动态调整投放时间和预算分配，让资源分配更具科学性。' }
      ]
    }
  },
  solution6: {
    nav: {
      highlight: '全天候',
      title: '技术支持',
      subtitle: '让问题迎刃而解',
      desc: '我们的技术团队为客户提供7×24小时的全方位支持服务，随时解决您在使用过程中遇到的各类问题',
      btn: '联系我们'
    },
    content1: {
      title: '使用过程中问题解答服务',
      desc: '无论是登录困难、功能使用疑惑，还是政策更新的困扰<br/>我们都将为您提供全方位支持',
      item1: {
        title: '如何联系我们？',
        desc: '让我们为您的广告投放保驾护航，解决所有使用中的问题，<br/>让您的业务运转更高效、更顺畅！',
        btn: '点击联系我们'
      },
      item2: {
        title: '常见问题库（FAQ）建设 提升服务效率',
        desc: '通过FAQ库，客户无需等待即可快速查找到常见问题的解决方法，大幅提高服务效率和客户体验',
        btn: '点击使用'
      }
    }
  }
}
